module.exports = __webpack_public_path__ + "static/media/iconcall.d8dd5a02.svg";